/*
 * TASK DESCRIPTION FIELDS
 *
 * Converts between the title-first description payload used by task creation flows and the
 * separate title and notes values displayed by the shared task popup controls.
 *
 * Recent changes:
 * - Added lossless line splitting and title-first composition for the task popup redesign.
 * - Reuses the shared popup text conversion while retaining task-specific whitespace cleanup.
 */

import { composeJoinedText, splitJoinedText } from '../../popup';

export interface TaskDescriptionFields {
  title: string;
  notes: string;
}

export const splitTaskDescription = (description: string): TaskDescriptionFields => {
  const { title, body } = splitJoinedText(description);
  return {
    title,
    notes: body,
  };
};

export const composeTaskDescription = (title: string, notes: string): string => {
  const normalizedTitle = title.trim();
  const normalizedNotes = notes.trimEnd();
  return composeJoinedText(normalizedTitle, normalizedNotes.trim() ? normalizedNotes : '');
};
